<template>
  <div class="odds-table-wrapper">
    <!-- Header rows (merged) -->
    <div class="odds-table-scroll">
      <table class="odds-table">
        <thead>
          <tr class="odds-table__header-top">
            <th rowspan="2" class="col-company">公司</th>
            <th colspan="3" class="col-group">讓球即時</th>
            <th colspan="3" class="col-group">標準即時</th>
            <th colspan="3" class="col-group">進球數即時</th>
          </tr>
          <tr class="odds-table__header-sub">
            <th class="col-val">主隊</th>
            <th class="col-line">讓球</th>
            <th class="col-val">客隊</th>
            <th class="col-val">主勝</th>
            <th class="col-val">和局</th>
            <th class="col-val">客勝</th>
            <th class="col-val">大球</th>
            <th class="col-val">大小</th>
            <th class="col-val">小球</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="loading">
            <tr v-for="i in 4" :key="i" class="odds-table__skeleton">
              <td v-for="j in 10" :key="j"><span class="skeleton skeleton-cell"></span></td>
            </tr>
          </template>
          <template v-else-if="companies.length">
            <tr
              v-for="company in companies"
              :key="company.company_id"
              class="odds-table__row"
            >
              <td class="col-company-name">{{ company.company_name }}</td>
              <!-- Handicap -->
              <td class="col-val">{{ fmt(company.handicap_home) }}</td>
              <td class="col-line handicap-line">{{ formatHandicap(company.handicap_line) }}</td>
              <td class="col-val">{{ fmt(company.handicap_away) }}</td>
              <!-- Standard -->
              <td class="col-val">{{ fmt(company.odds_home_win) }}</td>
              <td class="col-val">{{ fmt(company.odds_draw) }}</td>
              <td class="col-val">{{ fmt(company.odds_away_win) }}</td>
              <!-- Goals -->
              <td class="col-val">{{ fmt(company.goals_over) }}</td>
              <td class="col-val goals-line">{{ formatGoalsLine(company.goals_line) }}</td>
              <td class="col-val">{{ fmt(company.goals_under) }}</td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="10" class="odds-table__empty">暫無賠率資料</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { formatHandicap, formatGoalsLine } from '@/utils/odds'

export default {
  name: 'OddsTable',
  props: {
    companies: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    fmt(val) {
      if (val === null || val === undefined) return '—'
      return Number(val).toFixed(2).replace(/\.?0+$/, '') || '—'
    },
    formatHandicap,
    formatGoalsLine
  }
}
</script>

<style scoped>
.odds-table-wrapper {
  background: var(--bg-odds);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  padding: 0;
}

.odds-table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.odds-table {
  width: 100%;
  min-width: 520px;
  border-collapse: collapse;
  font-size: 12px;
}

/* Header */
.odds-table thead th {
  background: var(--bg-overlay);
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 11px;
  white-space: nowrap;
  text-align: center;
  padding: 6px 6px;
  border-bottom: 1px solid var(--border);
}

.odds-table__header-top .col-group {
  border-left: 1px solid var(--border-strong);
  color: var(--primary-light);
  font-size: 12px;
  letter-spacing: 0.03em;
}

.odds-table__header-sub th {
  border-left: 1px solid var(--border);
}

/* Body */
.odds-table__row {
  border-bottom: 1px solid var(--divider);
  transition: background var(--transition-fast);
}
.odds-table__row:hover {
  background: rgba(108,99,255,0.06);
}
.odds-table__row:last-child {
  border-bottom: none;
}

.odds-table td {
  text-align: center;
  padding: 7px 6px;
  color: var(--text-primary);
  white-space: nowrap;
}

.col-company-name {
  text-align: left;
  padding-left: 12px;
  color: var(--text-secondary);
  font-size: 12px;
  min-width: 50px;
}

.col-company {
  text-align: left;
  padding-left: 12px !important;
  min-width: 50px;
}

.col-line {
  color: var(--handicap);
  font-weight: 600;
}

.handicap-line {
  color: var(--handicap);
  font-weight: 600;
}

.goals-line {
  color: var(--accent-light);
  font-weight: 600;
}

/* Group borders */
.odds-table td:nth-child(2) { border-left: 1px solid var(--border-strong); }
.odds-table td:nth-child(5) { border-left: 1px solid var(--border-strong); }
.odds-table td:nth-child(8) { border-left: 1px solid var(--border-strong); }

/* Empty */
.odds-table__empty {
  color: var(--text-muted);
  padding: 20px !important;
  font-size: 13px;
}

/* Skeleton */
.skeleton-cell {
  display: block;
  height: 14px;
  width: 32px;
  margin: 0 auto;
}
</style>
